import { useBoolean } from '@insta-club/hooks';
import { Guides, Post } from '@insta-club/models';
import { t } from '@insta-club/translations';
import { BottomSheet, GuideDialog } from '@insta-club/ui';
import { useState } from 'react';
import ProgramCategory from '../program-category';
import PostingProgram from './program';

interface Props {
    post?: Post;
    hasChatBot: boolean;
    programID: number;
    dayNumber: number;
    canPerformTask: boolean;
}

const PostingTask: React.FC<Props> = ({ post, programID, dayNumber, hasChatBot, canPerformTask }) => {
    const sheet = useBoolean();
    const [guide, setGuide] = useState<Guides>();

    const openGuide = (guide: Guides) => {
        sheet.onFalse();
        setTimeout(() => {
            setGuide(guide);
        }, 300);
    };

    const closeGuide = () => {
        setGuide(undefined);
        sheet.onTrue();
    };

    return (
        <>
            <ProgramCategory
                title={t('program', t('posting'))}
                description={
                    !post
                        ? 'در این روز پست برای انتشار نداریم، پس وقت آزاد خودتو به بهترین شکل پر کن و از لحظاتت لذت ببر !'
                        : post?.is_done
                          ? 'تکمیل شده'
                          : `${post?.post_type?.subject}`
                }
                status={post?.is_done ? 'done' : 'progress'}
                onClick={sheet.onTrue}
                disabled={!post}
            />
            {post ? (
                <BottomSheet title={`${t('program')} ${t('posting')}`} open={sheet.value} onClose={sheet.onFalse}>
                    <PostingProgram
                        post={post}
                        onGuide={openGuide}
                        programID={programID}
                        dayNumber={dayNumber}
                        hasChatBot={hasChatBot}
                        canPerformTask={canPerformTask}
                    />
                </BottomSheet>
            ) : null}
            <GuideDialog open={guide !== undefined} onClose={closeGuide} guide={guide} />
        </>
    );
};

export default PostingTask;

